<app-header [fixed]="true"
  [navbarBrandFull]="{ src: 'assets/vendor/logo_onlychar.png', height: 35, alt: 'Logo' }"
  [navbarBrandMinimized]="{src: 'assets/vendor/logo_onlyimg.png', height: 45, alt: 'Logo'}"
  [asideMenuToggler]="false"
  [sidebarToggler]="false">

  <i class=" pl-3 fa fa-bars fa-lg text-muted mobile-menu" (click)="openMenu()"></i>
  <ul class="nav navbar-nav ml-auto">
    <li class="d-none d-lg-block text-muted"><strong>{{user}}</strong></li>
    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a class="nav-link cur-pointer" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
        dropdownToggle (click)="false">
        <img src="assets/img/avatars/ImmagineProfiloStandard.jpg" class="img-avatar" alt="admin@bootstrapmaster.com" />
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong>Menu</strong></div>
        <!--<a class="dropdown-item cur-pointer" [routerLink]="['/profile']"><i class="fa fa-user"></i> Profilo</a>-->
        <a class="dropdown-item cur-pointer" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </li>
  </ul>
</app-header>
<div class="app-body">
  <app-sidebar [fixed]="true" [display]="'lg'" id="Sidebar">
    <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="sidebarMinimized" class="sidebar-nav"
      (click)="openMenu()">
    </app-sidebar-nav>
    <app-sidebar-minimizer></app-sidebar-minimizer>
  </app-sidebar>
  <!-- Main content -->
  <main class="main">
    <div class="container-fluid px-3">
      <router-outlet></router-outlet>
    </div><!-- /.container-fluid -->
  </main>

</div>
<app-footer>
  <span><a target="_blank" href="https://www.innovactors.it/">Innov@ctors</a> &copy; {{year}}</span>
  <span class="ml-auto">Powered by <a href="https://www.innovactors.it/">Innov@ctors</a></span>
</app-footer>
